import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { PasswordInput } from "../../../common/form";
import { FormattedMessage } from "react-intl";

import validationUtils from "../../../../utils/ValidationUtils";
import { EXPORT_MEMBERS_VALIDATION_RULES } from "./exportMembersValidationRules";

class AuthorizationForm extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <Field
          id="authorizationCode"
          name="authorizationCode"
          component={PasswordInput}
          type="password"
          label={<FormattedMessage id="configurationsForm.authorizationCode" />}
        />
      </form>
    );
  }
}

AuthorizationForm.propTypes = {
  initialValues: PropTypes.object,
  handleSubmit: PropTypes.func,
};

export default connect(null, null, null, { withRef: true })(
  reduxForm({
    form: "exportAuthorization",
    validate: (values) =>
      validationUtils.validate(values, EXPORT_MEMBERS_VALIDATION_RULES),
  })(AuthorizationForm)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/exportMembers/AuthorizationForm.js